export function handleKeyDown(event, handleKey, handleFunction) {
  if (event.key === handleKey && handleFunction) {
    handleFunction();
  }
}
